// extracted by mini-css-extract-plugin
export default {"outer":"SearchInput_outer__5aBtl","container":"SearchInput_container__bT8+T","icon":"SearchInput_icon__2xix-","tagsContainer":"SearchInput_tagsContainer__6R9Hr"};